export default function CtaBlock({ data }) {
  const { title, subtitle, button_text, button_link, bg_color, image } = data || {};
  const bg = bg_color || "#5a6e3f";
  return (
    <section className="py-12 md:py-16">
      <div className="max-w-5xl mx-auto px-6 md:px-8">
        <div
          className="relative overflow-hidden rounded-3xl p-8 md:p-14"
          style={{ backgroundColor: bg, color: "var(--wp-cream)" }}
        >
          {image && (
            <>
              <div className="absolute inset-0 opacity-30" style={{ backgroundImage: `url(${image})`, backgroundSize: "cover", backgroundPosition: "center" }} />
              <div className="absolute inset-0" style={{ background: `linear-gradient(135deg, ${bg}E6 0%, ${bg}99 100%)` }} />
            </>
          )}
          <div className="relative">
            {title && (
              <h2 className="font-display text-3xl md:text-4xl lg:text-5xl leading-tight tracking-tight">
                {title}
              </h2>
            )}
            {subtitle && <p className="mt-4 text-base md:text-lg opacity-90 max-w-2xl">{subtitle}</p>}
            {button_text && button_link && (
              <a
                href={button_link}
                className="inline-flex items-center gap-2 mt-7 px-6 py-3 rounded-full font-semibold transition-transform hover:scale-[1.02]"
                style={{ backgroundColor: "var(--wp-cream)", color: bg }}
                data-testid="cta-block-button"
              >
                {button_text} <i className="fa-solid fa-arrow-right text-xs" />
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
